import { createSlice } from "@reduxjs/toolkit";
import {
  AllBrandsThunk,
  GetSingleBrandsThunk,
  AddBrandsThunk,
  UpdateBrandsThunk,
  DeleteBrandsThunk,
} from "./thunk";

const initialState = {
  brands: [],          // ✅ all brands list
  singleBrand: null,   // ✅ single brand detail
  loading: false,
  error: null,
  successMessage: null,
};

const brandsSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    clearBrandState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* -------------------- ALL BRANDS -------------------- */
      .addCase(AllBrandsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllBrandsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.brands = action.payload?.data || [];
      })
      .addCase(AllBrandsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- SINGLE BRAND -------------------- */
      .addCase(GetSingleBrandsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleBrandsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleBrand = action.payload?.data || null;
      })
      .addCase(GetSingleBrandsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- ADD BRAND -------------------- */
      .addCase(AddBrandsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(AddBrandsThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Brand added successfully!";
      })
      .addCase(AddBrandsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- UPDATE BRAND -------------------- */
      .addCase(UpdateBrandsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(UpdateBrandsThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Brand updated successfully!";
      })
      .addCase(UpdateBrandsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- DELETE BRAND -------------------- */
      .addCase(DeleteBrandsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(DeleteBrandsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.brands = state.brands.filter(
          (brand) => brand.uuid !== action.payload.uuid
        );
        state.successMessage = "Brand deleted successfully!";
      })
      .addCase(DeleteBrandsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBrandState } = brandsSlice.actions;
export default brandsSlice.reducer;
